
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface DashboardCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  value: string;
  bgClass?: string;
}

export function DashboardCard({ 
  icon, 
  title, 
  description, 
  value,
  bgClass = ""
}: DashboardCardProps) {
  return (
    <Card className={`transition-all duration-200 hover:shadow-md ${bgClass}`}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <div className="rounded-full p-2 bg-white/80 shadow-sm">{icon}</div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        <p className="text-xs text-muted-foreground mt-1">{description}</p>
      </CardContent>
    </Card>
  );
}
